import util from '@bmp-vue/core/api/util'
const controller = 'FluxoIrregular'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  PropostaAssinaturaCCB (th, data, callback) {
    th.$api.Multiplo.PropostaAssinaturaCCB(data).then(res => {
      if (th.$api.UI.PostLoadData(res, true)) {
        if (callback) callback()
      };
    });
  },
})
